import React, { useState } from 'react';
import { FiUser, FiChevronDown } from 'react-icons/fi';
import { toast } from '../../../Toast';
import { WidgetDef, GENERATE_NOTE_SINGLE } from '../types';
import { DemoHead, useWidgetSite } from '../shared';

const NAV = ['About', 'Projects', 'Investors', 'News', 'Contact'];

const MENU = [
    { label: 'My profile', sub: 'Name, email and password' },
    { label: 'Email alerts', sub: 'What you receive from us' },
    { label: 'My holdings', sub: 'Linked to the share register' },
    { label: 'Questions I asked' },
];

const SiteBar: React.FC = ({ children }) => {
    const { short } = useWidgetSite();
    return <div className="bar">
        <span className="brand">{short.toUpperCase()}</span>
        <nav>{NAV.map(n => <span key={n}>{n}</span>)}</nav>
        {children}
    </div>;
};

// spec 694:29860
const accountMenu: WidgetDef = {
    slug: 'account-menu',
    name: 'Account menu',
    description: 'Sign in, sign up and my profile',
    icon: <FiUser />,
    title: 'Account Menu Widget',
    installed: false,
    page: null,
    where: 'Site header · every page',
    views: null,
    metaLabel: 'Where',
    metaStatus: 'Not added to the header yet',
    demoPath: '/investors/',
    addNote: 'Paste this into your theme’s header, not into a page. It swaps to the profile menu on its own once the visitor signs in.',
    addBlocks: [
        { title: '1 · WordPress shortcode', code: '[investi_account instance="header" style="buttons"]' },
        { title: '2 · Or plain HTML', code: '<div data-investi-instance="header" data-investi="account"\n     data-investi-style="buttons"></div>', dark: true },
        {
            title: '3 · Or one button at a time',
            codes: [
                { label: 'Sign in only', code: '[investi_account part="sign-in"]' },
                { label: 'Sign up only', code: '[investi_account part="sign-up"]' },
                { label: 'My account only', code: '[investi_account part="my-account"]' },
            ],
            after: 'Use these if your theme puts the buttons in different places in the header.',
        },
    ],
    settings: [
        { kind: 'text', key: 'signInLabel', label: 'Sign in label', default: 'Sign In' },
        { kind: 'text', key: 'signUpLabel', label: 'Sign up label', default: 'Sign Up' },
    ],
    generateNote: GENERATE_NOTE_SINGLE,
    Demo: ({ settings: s }) => {
        const [open, setOpen] = useState(true);
        const preview = () => toast.info('Preview only: the menu does not sign anyone in or out here');
        return <div className="wd-account-menu">
            <DemoHead title="Account menu" sub="Sits in the site header. Two states — signed out and signed in." />
            <div className="wd-label">Signed out</div>
            <SiteBar>
                <span className="acts">
                    <button type="button" className="sign-in" onClick={preview}>{String(s.signInLabel)}</button>
                    <button type="button" className="sign-up" onClick={preview}>{String(s.signUpLabel)}</button>
                </span>
            </SiteBar>
            <div className="wd-label">Signed in</div>
            <SiteBar>
                <button type="button" className="wd-account-chip" aria-expanded={open} onClick={() => setOpen(!open)}>
                    <span className="wd-avatar">WT</span> Wallace Turner <FiChevronDown />
                </button>
            </SiteBar>
            {open && <div className="dropdown">
                {MENU.map(m => <button key={m.label} type="button" onClick={preview}><span>{m.label}</span>{m.sub && <small>{m.sub}</small>}</button>)}
                <button type="button" className="out" onClick={preview}><span>Sign out</span></button>
            </div>}
        </div>;
    },
};

export default accountMenu;
